var map = {
	"./template.bet575": 2165,
	"./template.bet575.tsx": 2165,
	"./template.bet777": 2166,
	"./template.bet777.tsx": 2166,
	"./template.betgalaxy": 2167,
	"./template.betgalaxy.tsx": 2167,
	"./template.betprofessor": 2168,
	"./template.betprofessor.tsx": 2168,
	"./template.betroyale": 2169,
	"./template.betroyale.tsx": 2169,
	"./template.betstride": 2170,
	"./template.betstride.tsx": 2170,
	"./template.buffalobet": 2171,
	"./template.buffalobet.tsx": 2171,
	"./template.chromabet": 2172,
	"./template.chromabet.tsx": 2172,
	"./template.default": 674,
	"./template.default.tsx": 674,
	"./template.epicodds": 1632,
	"./template.epicodds.tsx": 1632,
	"./template.fiestabet": 2173,
	"./template.fiestabet.tsx": 2173,
	"./template.forsport": 1633,
	"./template.forsport.tsx": 1633,
	"./template.gigabet": 2174,
	"./template.gigabet.tsx": 2174,
	"./template.goldenbet888": 2175,
	"./template.goldenbet888.tsx": 2175,
	"./template.goldenrush": 2176,
	"./template.goldenrush.tsx": 2176,
	"./template.hyperbet": 2177,
	"./template.hyperbet.tsx": 2177,
	"./template.juicybet": 2178,
	"./template.juicybet.tsx": 2178,
	"./template.junglebet": 2179,
	"./template.junglebet.tsx": 2179,
	"./template.magnumbet": 2180,
	"./template.magnumbet.tsx": 2180,
	"./template.oldgill": 2181,
	"./template.oldgill.tsx": 2181,
	"./template.puntcity": 2182,
	"./template.puntcity.tsx": 2182,
	"./template.puntgenie": 2183,
	"./template.puntgenie.tsx": 2183,
	"./template.pyramidbet": 2184,
	"./template.pyramidbet.tsx": 2184,
	"./template.questbet": 2185,
	"./template.questbet.tsx": 2185,
	"./template.slambet": 2186,
	"./template.slambet.tsx": 2186,
	"./template.sterlingparker": 2187,
	"./template.sterlingparker.tsx": 2187,
	"./template.sugarcastle": 2188,
	"./template.sugarcastle.tsx": 2188,
	"./template.templebet": 2189,
	"./template.templebet.tsx": 2189,
	"./template.titanbet": 2190,
	"./template.titanbet.tsx": 2190,
	"./template.ts": 988,
	"./template.vikingbet": 2191,
	"./template.vikingbet.tsx": 2191,
	"./template.volcanobet": 2192,
	"./template.volcanobet.tsx": 2192,
	"./template.wellbet": 2193,
	"./template.wellbet.tsx": 2193
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2468;